import type { FloorFallView } from "./models"

/** A one-storey drop at rest, by gravity: how long the first storey takes (server default.ts handleFloorFall). */
export const FLOOR_FALL_MS = 240
/** How long a body that stepped off one storey takes to come down on the next. */
export const FLOOR_FALL_ARRIVAL_MS = 300
/** Time reserved at the end of landing recovery for the reversed hurt animation. */
export const FLOOR_FALL_RISE_MS = 600

export const isExteriorFloorFall = (view?: FloorFallView): boolean =>
    view?.exterior === true && view.phase !== "landed"

/** Body height relative to the current destination floor, in world pixels. */
export const floorFallOffsetAt = (view: FloorFallView, elapsedMs: number): number => {
    if (!view.trajectory || view.phase === "landed") return 0
    const { gravity, distanceBefore, endElapsedMs, totalDistance } = view.trajectory
    const elapsed = Math.max(0, view.phase === "falling" && totalDistance !== undefined
        ? elapsedMs : Math.min(endElapsedMs, elapsedMs))
    // During a delayed room snapshot the already streamed lower floors remain in
    // view. Continue through them, but never extrapolate beyond supported ground.
    const fallen = Math.min(totalDistance ?? distanceBefore + view.distance, gravity * elapsed * elapsed / 2)
    return fallen - distanceBefore - view.distance
}
